import { useAuth0 } from "@auth0/auth0-react";
import React from "react";

import { Link } from "react-router-dom";

import config from "../../config.json";

const LogoutButton = () => {
  const { logout } = useAuth0();

  const logoutHandler = async () => {
    console.log("Logout: "+window.location.origin)
    logout({ logoutParams: { returnTo: window.location.origin } })
  }

  return (
    <li className="nav-item dropdown">
      <a href="/" className="nav-link  px-sm-3 px-3 me-1" id="dropdownUser" data-bs-toggle="dropdown" aria-expanded="false">
        <div> {/*} className="text-center">*/}
          <i className="bi bi-person-circle h4 dropdown-toggle"></i></div></a> {/*20240419 jag dropdown-toggle adds the caret*/}
      <ul className="dropdown-menu dropdown-menu-end text-small shadow" aria-labelledby="dropdownUser">
        {/* 20240329 jag save for later
        <li><a class="dropdown-item" href="#">Settings</a></li>
        <li><a class="dropdown-item" href="#">Profile</a></li>
        <li>
          <hr class="dropdown-divider" />
        </li>*/}
        <li>
          <Link className="dropdown-item" onClick={() => logoutHandler()} href="#">Signout</Link>
        </li>
      </ul>
  </li>
  );
};

export default LogoutButton;